import { render, staticRenderFns } from "./InwardHandlings.vue?vue&type=template&id=626282f1&"
import script from "./InwardHandlings.vue?vue&type=script&lang=js&"
export * from "./InwardHandlings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports